import { OTPStatus } from '@/online-merchant-onboarding/pages/Register/Register.types';

const GlobalConstants = {
	REGISTER_CONTAINERS: {
		SIGNUP: 'SIGNUP',
		OTP: 'OTP',
	},
	OTP_STATUS: {
		NOT_SUBMITTED: 'NOT_SUBMITTED',
		SUBMITTED: 'SUBMITTED',
		INVALID_OTP: 'INVALID_OTP',
		VALID: 'VALID',
		OTP_EXPIRED: 'OTP_EXPIRED',
		ATTEMPTS_EXHAUSTED: 'ATTEMPTS_EXHAUSTED',
	} as Record<OTPStatus, OTPStatus>,
	KEYBOARD: {
		BACKSPACE: 'Backspace',
		DELETE: 'Delete',
		ARROW_LEFT: 'ArrowLeft',
		ARROW_RIGHT: 'ArrowRight',
		ARROW_DOWN: 'ArrowDown',
		ARROW_UP: 'ArrowUp',
		SPACEBAR: 'Spacebar',
		SPACE: 'Space',
		PLUS: '+',
		MINUS: '-',
		PERIOD: '.',
		KEY_e: 'e',
		KEY_E: 'E',
		UNIDENTIFIED: 'Unidentified',
	},
	KYC_STEPS: {
		BUSINESS_DETAILS: 'BUSINESS_DETAILS',
		KYC_COMPLETED: 'KYC_COMPLETED',
		BANK_SECTION: 'BANK_SECTION',
		GST_PAN_SECTION: 'GST_PAN_SECTION',
		GST_PAN_DOCUMENT_UPLOAD_SECTION: 'GST_PAN_DOCUMENT_UPLOAD_SECTION',
	},
	KYC_STATUS: {
		PENDING: 'PENDING',
		IN_PROGRESS: 'IN_PROGRESS',
		COMPLETED: 'COMPLETED',
		PSEUDO_SUCCESS: 'PSEUDO_SUCCESS',
		ERROR: 'ERROR',
	},
	ACCOUNT_MIGRATION_STATUS: {
		PV_ONBOARDING_VERIFICATION_FAILED: 'PV_ONBOARDING_VERIFICATION_FAILED',
	},
	PV_STATE: {
		NOT_STARTED: 'NOT_STARTED',
		CREATED: 'CREATED',
		IN_PROGRESS: 'IN_PROGRESS',
		SUCCESS: 'SUCCESS',
		FAILURE: 'FAILURE',
		INVALIDATED: 'INVALIDATED',
		ABORTED: 'ABORTED',
		SKIPPED: 'SKIPPED',
		PSEUDO_SUCCESS: 'PSEUDO_SUCCESS',
	},
	ACCEPTED_ORIGINS: ['*'],
	KYC_SDK_ACTIONS: {
		SUBMIT_TRIGGERED: 'SUBMIT_TRIGGERED',
		TERMINAL_ACTION: 'TERMINAL_ACTION',
		PAGE_VIEW: 'PAGE_VIEW',
		KYC_POLLING_TIMEOUT: 'KYC_POLLING_TIMEOUT',
		SUBMIT_FAILED: 'SUBMIT_FAILED',
		KYC_COMPLETED: 'KYC_COMPLETED',
		SUBMIT_COMPLETED: 'SUBMIT_COMPLETED',
	},
	REGISTER_ERROR_CODE: {
		REGISTRATION_OTP_ERROR: 'REGISTRATION_OTP_ERROR',
		BANNED: 'BANNED',
		EMAIL_EXISTS: 'EMAIL_EXISTS',
		PHONE_EXISTS: 'PHONE_EXISTS',
		WEBSITE_URL_EXISTS: 'WEBSITE_URL_EXISTS',
		MERCHANT_ALREADY_EXISTS: 'MERCHANT_ALREADY_EXISTS',
		WEB_SIGNUP_BLOCKED: 'WEB_SIGNUP_BLOCKED',
	},
	MERCHANT_PROFILE_KEY: 'MERCHANT_PROFILE_KEY',
	KYC_INIT_MERCHANT_TYPE: {
		ONLINE_MERCHANT_ONBOARDING_VERIFICATION:
			'ONLINE_MERCHANT_ONBOARDING_VERIFICATION',
	},
	KYC_INIT_VERSION: '1.0.0',
	SERVICE_LINES_POLLING_TIME: 5 * 60 * 1000,
	DEFAULT_RATE: '0',
	PAYMENT_SOLUTION_STATUS: {
		NOT_INITIATED: 'NOT_INITIATED',
		IN_PROGRESS: 'IN_PROGRESS',
		SUCCESS: 'SUCCESS',
		FAILED: 'FAILED',
	},
	PAYMENT_SOLUTION: {
		B2B_PG: 'B2B_PG',
	},
	PG_PRODUCT_PAGE_INFO: {
		SUB_LABEL:
			'*0% will be there till the end of the fourth month starting from the month of release of production key credentials. 1.85% will be charged post that. Terms and Conditions apply.',
		FEATURES: [
			'Accept payments with UPI, Cards and Netbanking',
			'Manage payments with Dashboard',
			'Highly secure and easy Integration',
			'No hidden charges, set up fee, maintainance fee',
		],
	},
	ONBOARDING_TYPE: {
		SELF: 'SELF',
	},
	FRAUD_DETECTED: 'FRAUD_DETECTED',
	PG_SUPPORT_EMAIL: 'merchant-pgsupport@phonepe.com',
	REFERRAL_CODE: 'referral-code',
};

export default GlobalConstants;
